<template>
  <!-- 底部按钮栏 -->
  <footer :style="{'flex-direction': cConf.alignRight ? 'row-reverse' : ''}">
    <div v-if="config.btn_search_order" class="icon-only" @click="search()">
      <img src="../../assets/img/detail/search.svg" alt="">
    </div>
    <div v-if="!isGoogleSource && config.btn_contact"  class="icon-only" @click="service()">
      <a>
        <img src="../../assets/img/detail/service.svg" alt="">
      </a>
    </div>
    <div class="buy-now" @click="pay()" :style="{'width': (100 - (config.btn_search_order + (!isGoogleSource && config.btn_contact)) * 15) + '%'}">
      <img src="../../assets/img/detail/cart.svg" alt="">
      {{text}}
    </div>
  </footer>
</template>

<script>
  import configService from '../../util/config.js';
  export default {
    props: {
      text: {
        type: String,
        default: ''
      },
      config: {
        type: Object,
        default: {}
      }
    },
    data() {
      return {
        msgUrl: configService.msgUrl,
        cl: sessionStorage.cl,
        isGoogleSource: source === sourceData.googleSource,
        cConf: cConf
      }
    },
    methods: {
      /**
       * 订单查询
       */
      search() {
        this.$emit('search');
      },
      /**
       * 客服咨询
       */
      service() {
        if(cConf.serviceLineMe) {
          window.open('https://line.me/ti/p/UnTgQVExys#~')
        } else{
          window.open(this.msgUrl)
        }
        this.$emit('service');
      },
      /**
       * 下单
       */
      pay() {
        this.$emit('pay');
      }
    }
  }
</script>

<style scoped>
  footer {
    position: fixed;
    bottom: -1px;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 100%;
    max-width: 640px;
    height: 50px;
    display: flex;
  }

  footer > div {
    height: 50px;
    border: 1px solid #bbb;
    border-radius: 4px;
    cursor: pointer;
  }

  footer .icon-only {
    width: 15%;
    padding: 6px 0;
    background: #fff;
  }

  footer .icon-only img{
    width: 100%;
    height: 100%;
  }

  footer .buy-now {
    width: 100%;
    text-align: center;
    line-height: 50px;
    font-weight: bold;
    background: #ED3323;
    color: #fff;
    font-size: 1.25rem;
  }

  footer .buy-now img {
    width: 2rem;
    font-size: 0;
    position: relative;
    top: -3px;
  }

</style>



// WEBPACK FOOTER //
// src/components/detail/footer.vue